import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import WifiOffRoundedIcon from '@mui/icons-material/WifiOffRounded';
import { FC } from 'react';
import { useTranslations } from 'use-intl';

import ErrorScreen from '../ErrorScreen/ErrorScreen';
import { logout } from '../../keycloak';

interface AppErrorProps {
  message?: string | null;
  /** Replaces the generic description, for a known failure the user can't retry past. */
  description?: string;
  showLogout?: boolean;
}

const isNetworkError = (message?: string | null) =>
  !!message && /network|timeout|failed to fetch/i.test(message);

const AppError: FC<AppErrorProps> = ({ message, description, showLogout = false }) => {
  const t = useTranslations('errors.app');
  const offline = isNetworkError(message);

  return (
    <ErrorScreen
      documentTitle={offline ? t('connectionLost') : t('somethingWentWrongTitle')}
      icon={
        offline ? (
          <WifiOffRoundedIcon color='error' />
        ) : (
          <ErrorOutlineRoundedIcon color='error' />
        )
      }
      title={offline ? t('backShortly') : t('somethingWentWrong')}
      description={
        description ??
        (offline
          ? t('offlineDescription')
          : t('genericDescription'))
      }
      onRetry={() => window.location.reload()}
      onLogout={showLogout ? logout : undefined}
    />
  );
};
export default AppError;
